import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgFuriousSelectedEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M18.87 30.04c0 .74.6 1.34 1.34 1.34h.1v-2.69h-.1c-.74 0-1.34.61-1.34 1.35ZM26.19 28.69h-1.44v2.69h1.44v-2.69ZM23.25 28.69h-1.44v2.69h1.44v-2.69Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M24 8C15.18 8 8 15.18 8 24s7.18 16 16 16 16-7.18 16-16S32.82 8 24 8Zm3.79 24.88h-7.58c-1.57 0-2.84-1.28-2.84-2.84a2.85 2.85 0 0 1 2.84-2.84h7.58c1.57 0 2.84 1.28 2.84 2.84 0 1.56-1.27 2.84-2.84 2.84Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M27.79 28.69h-.1v2.69h.1c.74 0 1.34-.6 1.34-1.34 0-.74-.6-1.35-1.34-1.35Z",
    fill: "currentColor"
  }));
}

export { SvgFuriousSelectedEmojiSecondary as default };
